import {isEditorMobileVariant} from '@Libraries/is-editor-mobile-variant';
import {MobilePageSelectionModeState} from '@PosterWhiteboard/poster/poster.types';
import {getPosterUi} from '@PosterWhiteboard/ui/poster-ui';
import {isPageNavigationBlocked} from '@PosterWhiteboard/libraries/poster-page-navigation-guard.library';

export const transitionToMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.TRANSITIONING) {
    window.posterEditor?.whiteboard?.redux.setMobilePageSelectionModeState(MobilePageSelectionModeState.TRANSITIONING);
  }
};

export const exitMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.INACTIVE) {
    window.posterEditor?.whiteboard?.redux.setMobilePageSelectionModeState(MobilePageSelectionModeState.INACTIVE);
  }
};

export const activateMobilePageSelectionMode = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  window.posterEditor?.whiteboard?.clearSelection();

  const currentState = window.PMW.redux.store.getState().posterEditor.mobilePageSelectionModeState;

  if (currentState !== MobilePageSelectionModeState.ACTIVE) {
    openPageOptionsModal();
    window.posterEditor?.whiteboard?.redux.setMobilePageSelectionModeState(MobilePageSelectionModeState.ACTIVE);
  }
};

export const openPageOptionsModal = (): void => {
  if (!isEditorMobileVariant()) {
    return;
  }

  const areMultiPagesEnabledForUser = window.PMW.isMultipageAvailable;
  if (!areMultiPagesEnabledForUser) {
    return;
  }

  if (isPageNavigationBlocked()) {
    return;
  }

  getPosterUi().openPosterEditorPageOptionsModal();
};
